import PARENT from '../types';

export const SET_CUTOFFS = `${PARENT}/SET_CUTOFFS`;
